export default __webpack_public_path__ + "static/cercle_vicieux_fr-a79d187d609e852b8e5f9c0322998f11.mp4";